import { trpc } from "@/lib/trpc";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { httpBatchLink } from "@trpc/client";
import { createRoot } from "react-dom/client";
import superjson from "superjson";
import App from "./App";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

const trpcClient = trpc.createClient({
  links: [
    httpBatchLink({
      url: "/api/trpc",
      transformer: superjson,
      fetch(input, init) {
        return globalThis.fetch(input, {
          ...(init ?? {}),
          credentials: "include",
        });
      },
    }),
  ],
});

// Uretimde stil dosyasi engelsiz (preload) yuklenir; stilsiz ilk boyama ve CLS olmasin
// diye React, CSS uygulanana kadar (en fazla 2 sn) bekler.
function stilHazir(): Promise<void> {
  return new Promise(resolve => {
    const link = document.querySelector<HTMLLinkElement>("link[data-am-css]");
    if (!link) return resolve();
    const baslangic = Date.now();
    const uygulandi = () => {
      try {
        return link.rel === "stylesheet" && !!link.sheet && link.sheet.cssRules.length > 0;
      } catch { return link.rel === "stylesheet" && !!link.sheet; }
    };
    const kontrol = () => {
      if (uygulandi() || Date.now() - baslangic > 2000) return resolve();
      requestAnimationFrame(kontrol);
    };
    kontrol();
  });
}

stilHazir().then(() => {
  createRoot(document.getElementById("root")!).render(
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </trpc.Provider>
  );
});
